module.exports = {"511133100":"民建镇","511133101":"荣丁镇","511133102":"下溪镇","511133103":"苏坝镇","511133104":"烟峰镇","511133200":"劳动乡","511133201":"建设乡","511133203":"石梁乡","511133204":"荍坝乡","511133206":"民主乡","511133207":"老河坝乡","511133209":"雪口山乡","511133210":"镇江庙乡","511133211":"大竹堡乡","511133215":"袁家溪乡","511133216":"沙腔乡","511133217":"三河口乡","511133221":"梅子坝乡","511133223":"高卓营乡","511133226":"永红乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511133.json
// module id = 2155
// module chunks = 0